import { render } from "./TheOverlay.vue?vue&type=template&id=4d368e11"
import script from "./TheOverlay.vue?vue&type=script&lang=js"
export * from "./TheOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__